module.exports = __webpack_public_path__ + "img/banner0305_2.d6c7b0a6.jpg";